const urlRelatoriosLog = "/v1/RelatoriosLog";

const service = {
  methods: {
    $obterRelatorioLogHabilidade(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogHabilidade`, params);
    },
    $obterRelatorioLogCSVHabilidade(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogHabilidadeCsv`, params);
    },
    $obterRelatorioLogPDFHabilidade(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogHabilidadePdf`, this.$getParamsObject(params));
    },
  }
};

export default service;
